import { ENV } from "../Utils";

export const postQuestionUseCase = async (accessToken, threadId, data) => {
  try {
    accessToken = null;
    //console.log(accessToken);
    // Construye la URL con los parámetros de consulta
    const url = new URL(
      `${ENV.BASE_API}/${ENV.API_ROUTES.THREADGET}/${threadId}`,
    );
    url.searchParams.append("data", data);

    const resp = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Asegúrate de enviar el token de autorización
      },
    });

    if (!resp.ok) {
      throw new Error(`Error fetching thread: ${resp.statusText}`);
    }

    const { Solicitudes } = await resp.json();
    //console.log(Solicitudes);

    return Solicitudes;
  } catch (error) {
    console.log(error);
    throw new Error("Error posting question");
  }
};
